<template lang="pug">
.public-edital-layout
  EditalNavbar
  main.public-edital-layout__main
    .public-edital-layout__content
      slot
  EditalFooter
</template>

<script>
import EditalNavbar from '@/components/editais/EditalNavbar'
import EditalFooter from '@/components/editais/EditalFooter'

export default {
  name: 'PublicEditalLayout',
  components: {
    EditalNavbar,
    EditalFooter
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Poppins:wght@600&display=swap');

.public-edital-layout {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

.public-edital-layout__main {
  flex: 1;
  padding-bottom: 5rem;
  padding-top: 3.75rem;
  width: 100%;
}

.public-edital-layout__content {
  margin-left: auto;
  margin-right: auto;
  max-width: 1600px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
}

@media (max-width: 1023px) {
  .public-edital-layout__content {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .public-edital-layout__main {
    padding-bottom: 3.75rem;
    padding-top: 2.5rem;
  }
}

@media (max-width: 640px) {
  .public-edital-layout__main {
    padding-bottom: 3rem;
    padding-top: 1.5rem;
  }
}
</style>
